export default __webpack_public_path__ + "static/media/antisocial.1e36c1e9.png";